import React from 'react';
import createTheme from '@mui/material/styles/createTheme';
import MuiThemeProvider from '@mui/material/styles/ThemeProvider';
import { ThemeOptions } from '@mui/material/styles';

export const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#2a3e92',
    },
    secondary: {
      main: '#f68920',
    },
  },
};

const theme = createTheme(themeOptions);



export interface IThemeProviderProps { }

const ThemeProvider: React.FC<React.PropsWithChildren<IThemeProviderProps>> = ({ children }) => {
    return (
        <div>
            <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
        </div>
    );
};

export default ThemeProvider;
